import nanoid from 'nanoid';
import { logMSG } from '../util';

const uuid = () => `nanoid(${JSON.stringify(nanoid(8))})`;
const TYPE_CALLBACK = '$callback';
let store = [];

export default {
    /**
     * 发送消息
     *
     * @param {window} to 目标 window
     * @param {string} type 事件类型
     * @param {*} res 携带信息
     * @returns {promise}
     */
    send(to:Window, type:string, payload:any = {}):Promise<any> {
        logMSG('send', type, payload);
        /** payload 携带 type / callbackId */
        payload.$type = payload.$type || type;
        // payload.$callbackId = payload.$callbackId || uuid();
        payload.$messageId = uuid();
        payload.$windowName = window.name;

        /** 执行发送 */
        to.postMessage(payload, '*');

        if (type !== TYPE_CALLBACK) {
            /** 监听返回 */
            return new Promise((resovle) => {
                const callback = this.on(TYPE_CALLBACK, (data: any) => {
                    /** 匹配 callbackId 为发送时的 $messageId */
                    if (data.$callbackId === payload.$messageId) {
                        logMSG('send::callback', type, payload, '::', data);
                        resovle(data);

                        /** 销毁监听, 即只接收第一次回复 */
                        callback.off();
                    }
                });
                /** 某些事件不需要回复, 超时后移除回调监听 */
                setTimeout(() => {
                    callback.off();
                }, 60000);
            });
        } else {
            /** 回调事件不再监听回复 */
            return;
        }
    },

    /**
     * 监听消息
     *
     * @param {string} type
     * @param {requestCallback} callback
     * @return {{ type:string, off():void }}
     *
     * @callback requestCallback
     * @param {object} data
     * @param {event} event
     * @param {replyCallback} reply
     *
     * @callback replyCallback
     * @param {*} data
     */
    on(type: string, callback: Function): { type: string; off(onlyOff?: boolean): void; } {
        logMSG('on', type);
        /** 定义消息处理方法 */
        const entry = (e:any) => {
            /** 匹配 type  */
            if (e.data && e.data.$type && e.data.$type === type) {
                logMSG('on::receive', type, '::', e);
                /** 执行回调, 定义回复消息方法 */
                callback(e.data, e, (res:any = {}) => {
                    logMSG('on::receive::replay', type, '::', e, '::', res);

                    if (e.data.$callbackId) {
                        /** 兼容老版本 */
                        res.$callbackId = e.data.$callbackId;
                        return this.send(e.source, 'callback', res);
                    } else {
                        /** 新版本非回调事件移除 $callbackId, 回调事件重命名 */
                        res.$callbackId = e.data.$messageId;
                        return this.send(e.source, TYPE_CALLBACK, res);
                    }
                });
            }
        };

        /** 监听事件 */
        window.addEventListener('message', entry);

        /** 创建事件实例 */
        const instance = {
            $id: uuid(),
            type,
            off(onlyOff?: boolean) {
                /** 销毁当前实例监听事件 */
                window.removeEventListener('message', entry);
                if (!onlyOff) {
                    store = store.filter(ele => ele.$id !== this.$id);
                }
            }
        };

        /** 加入事件仓库 */
        store.push(instance);

        /** 返回事件实例 */
        return instance;
    },

    /**
     * 销毁指定 type 监听事件
     *
     * @param {string} type
     */
    off(type:string) {
        if (type) {
            store.filter(ele => ele.type === type).forEach(ele => ele.off(true));
            store = store.filter(ele => ele.type !== type);
        }
    },

    /**
     * 判断是否已监听指定 type 事件
     *
     * @param {string} type
     */
    has(type:string) {
        if (type) {
            return store.find(ele => ele.type === type);
        }
        return false;
    },

    /**
     * 销毁全部监听事件
     */
    offAll() {
        store.forEach(ele => ele.off(true));
        store = [];
    }
}
